export default __webpack_public_path__ + "static/media/pizza-real.a730db02.png";